import { Box } from "@mui/material"
import { Outlet } from "@tanstack/react-router"
import type { FC } from "react"

import { DashboardTabs } from "./DashboardTabs"

export const DashboardLayout: FC = () => (
  <Box className='flex h-full flex-col gap-y-6 pt-16' data-testid='dashboard.page'>
    <DashboardTabs />
    <Outlet />
  </Box>
)
